import { Injectable } from "@angular/core";
import { FetchStatusSelector } from "@obg/ngrx-utils";
import { CoreState } from "@obg/ngx.core";

import { CommonState } from "../../state";

import { ACTION_PREFIX } from "./multi-session-limit.action";
import { MultiSessionLimits } from "./multi-session-limit.model";

@Injectable({
	providedIn: "root",
})
export class MultiSessionLimitSelector {
	isBusy() {
		return (state: CoreState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	}

	get() {
		return (state: CommonState): MultiSessionLimits | undefined => state.multiSessionLimit.multiSessionLimits;
	}
}
